import { statisticsPages } from '../../../constants/statisticsPages';

const {
  active,
  chargeable,
  expired,
  immediate,
  retry,
  root,
  newRoot,
  lifetime,
  all,
} = statisticsPages;

export const paths = {
  root: `/${root}`,
  newRoot: `/${newRoot}`,
  [all]: `/${all}`,
  [active]: `/${active}`,
  [chargeable]: `/${chargeable}`,
  [expired]: `/${expired}`,
  [immediate]: `/${immediate}`,
  [retry]: `/${retry}`,
  [lifetime]: `/${lifetime}`,
};
